module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/12.2d4d3f6c.png";